import { useCallback, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { v4 as uuid } from 'uuid';
import {
  showPersonNameDialog,
  hidePersonNameDialog,
} from '../store/actions/personNameDialog.actions';

export const usePersonNameDialog = () => {
  const dispatch = useDispatch();
  const savedResult = useSelector((state) => state.personNameDialog.savedResult);
  const dialogs = useSelector((state) => state.personNameDialog.dialogs);
  const pendingRequests = useRef(new Map());

  useEffect(() => {
    if (!savedResult) return;
    const onSaved = pendingRequests.current.get(savedResult.requestId);
    pendingRequests.current.delete(savedResult.requestId);
    onSaved?.(savedResult.personName);
  }, [savedResult]);

  useEffect(() => {
    const activeRequests = new Set(dialogs.map((dialog) => dialog.requestId));
    pendingRequests.current.forEach((_, requestId) => {
      if (!activeRequests.has(requestId)) pendingRequests.current.delete(requestId);
    });
  }, [dialogs]);

  const openPersonNameDialog = useCallback(
    (options = {}) => {
      const { onSaved, ...dialogOptions } = options;
      const requestId = uuid();
      pendingRequests.current.set(requestId, onSaved);
      dispatch(showPersonNameDialog({ ...dialogOptions, requestId }));
      return requestId;
    },
    [dispatch]
  );

  const closePersonNameDialog = useCallback(
    (requestId) => {
      pendingRequests.current.delete(requestId);
      dispatch(hidePersonNameDialog(requestId));
    },
    [dispatch]
  );
  return { openPersonNameDialog, closePersonNameDialog };
};
